export default {
  title: {
    text: "历年各地区半导体材料销售额",
    left: "center",
  },
  grid: {
    top: 80,
    right: "15%",
  },
  legend: {
    orient: "vertical",
    left: "right",
    data: [
      "2010",
      "2011",
      "2012",
      "2013",
      "2014",
      "2015",
      "2016",
      "2017",
      "2018",
    ],
  },
  tooltip: {},
  dataset: {
    source: [
      [
        "category",
        "2010",
        "2011",
        "2012",
        "2013",
        "2014",
        "2015",
        "2016",
        "2017",
        "2018",
      ],
      ["中国大陆", "4.4", "5.2", "5.3", "5.8", "6", "6.2", "7", "8", "8.6"],
      [
        "中国台湾",
        "9.5",
        "10.2",
        "10.6",
        "9",
        "9.7",
        "9.6",
        "9.5",
        "10.2",
        "11.6",
      ],
      ["韩国", "6.6", "7.5", "7.6", "7", "7.1", "7.2", "7.3", "7.6", "9"],
      ["日本", "9.6", "9.2", "8.6", "7.5", "7.4", "6.8", "6.6", "7", "7.5"],
      ["北美", "4.6", "4.7", "4.68", "4.68", "4.9", "4.9", "4.8", "5", "5.6"],
      ["欧洲", "3.3", "3.4", "3.2", "3.2", "3.2", "3.18", "3.4", "3.8", "4"],
    ],
  },
  xAxis: {
    type: "category",
    axisLabel: {},
  },
  yAxis: {
    type: "value",
    name: "销售额/十亿元",
    min: 0,
    max: 12,
    interval: 3,
    axisLabel: {
      formatter: "{value} ",
      textStyle: {},
    },
  },

  series: [
    { type: "bar" },
    { type: "bar" },
    { type: "bar" },
    { type: "bar" },
    { type: "bar" },
    { type: "bar" },
    { type: "bar" },
    { type: "bar" },
    { type: "bar" },
  ],
};
